import { canv } from '@/canv/global.js'

export class shapeCircle {

    constructor() {

    }

    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width * 2/3 - 2 * horizontalPadding;
        var allowedHeight = height * 2/3 - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        canv.ctx.beginPath();
        canv.ctx.ellipse(x + width / 2, y + height / 2, height / 2, width / 2, Math.PI / 2, 0, 2 * Math.PI);
        canv.ctx.closePath();
    }

    getAvatar(color) {
        return `
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="40" cy="40" r="40" fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12.5" cy="12.5" r="12" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
